import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-70-small', 'Number70Small', [["path",{"d":"M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0"}],["path",{"d":"M6 8h4l-2 8"}]]);